//These strings will be used to compare the name configured in the Vault, hence,
//It must be the very same name as configured over there.
export enum FeatureNames {
    TOKEN_HANDLING = 'TOKEN_HANDLING',
    NFT_RESALE = 'NFT_RESALE',
    SEND_NFT = 'SEND_NFT',
    LETTER_OF_CREDIT = 'LETTER_OF_CREDIT',
    USER_KYC='USER_KYC',
    COIN_PAYMENTS_KAIROS = 'COIN_PAYMENTS_KAIROS',
    DIGITAL_BANKING_KAIROS = 'DIGITAL_BANKING_KAIROS',
    BDM_PRICES='BDM_PRICES',
    SPECIAL_PRICES='SPECIAL_PRICES'
}